var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 18,
    viewBox: "0 0 18 18",
    width: 18,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m9.26365 2.9636c.35148-.35147.92135-.35147 1.27275 0l5.4 5.4c.3515.35147.3515.92132 0 1.27279l-5.4 5.40001c-.3514.3515-.92127.3515-1.27275 0-.35147-.3515-.35147-.9213 0-1.2728l3.86365-3.8636h-10.42725c-.49706 0-.9-.40295-.9-.9 0-.49706.40294-.9.9-.9h10.42725l-3.86365-3.86361c-.35147-.35147-.35147-.92132 0-1.27279z",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.7d704c3ebebcece1f98a07cf421fd7c7.svg";
export { ForwardRef as ReactComponent };